export default function TermsPage() {
  return (
    <section className="py-16 px-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-[#055862] mb-6">Terms & Conditions</h1>
      <p className="text-gray-700 mb-4">
        By accessing or using iDisKover, you agree to be bound by the terms described herein...
      </p>
      <ul className="list-disc pl-6 space-y-2 text-gray-700 text-base">
        <li>Use of this service is subject to applicable copyright and licensing policies.</li>
        <li>Users shall not redistribute or republish any licensed content without written permission.</li>
        <li>Accounts found violating these rules may be suspended or revoked.</li>
        <li>The platform may collect usage data in accordance with our privacy policy.</li>
      </ul>
    </section>
  );
}
